export const NotificationApiEndpoints = {
  POST_GET_SMS_TEXT_METADATA: {
    path: '/v1/sms-text-metadata',
  },
  POST_VALIDATE_EMAIL_ADDRESS: {
    path: '/v2/validate/email-address',
  },
  POST_PARSE_PHONE_NUMBER: {
    path: '/v1/parse/phone-number',
  },
};
